var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuLove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.213,
    height: 20,
    viewBox: "0 0 14.213 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1522",
    "data-name": "Rectangle 1522",
    width: 14.213,
    height: 20,
    fill: "#ee3d4a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "People_We_Love",
    "data-name": "People We Love",
    transform: "translate(-320 -228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31534",
    "data-name": "Group 31534",
    transform: "translate(320 228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31533",
    "data-name": "Group 31533",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11896",
    "data-name": "Path 11896",
    d: "M10.127,9.867a5.787,5.787,0,0,0,1.842-4.327C11.969,2.485,9.763,0,7.052,0S2.134,2.485,2.134,5.539A5.853,5.853,0,0,0,4.016,9.9,7.06,7.06,0,0,0,0,16.3v3.137A.566.566,0,0,0,.566,20h13.08a.566.566,0,0,0,.566-.566V16.3a7.149,7.149,0,0,0-4.085-6.431Zm2.953,9H1.132V16.3a5.939,5.939,0,0,1,4.234-5.716.566.566,0,0,0,.1-1.04,4.52,4.52,0,0,1-2.2-4c0-2.43,1.7-4.407,3.786-4.407s3.785,1.977,3.785,4.407a4.536,4.536,0,0,1-2.17,3.985.566.566,0,0,0,.116,1.039,6.006,6.006,0,0,1,4.3,5.735Z",
    transform: "translate(0 0)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11897",
    "data-name": "Path 11897",
    d: "M7.558,14.079a2.065,2.065,0,0,0-2.9,2.937c.63.7,2.46,2.189,2.537,2.252a.564.564,0,0,0,.357.127h.013a.565.565,0,0,0,.357-.127C8,19.2,9.828,17.716,10.458,17.016a2.064,2.064,0,0,0-2.9-2.937Zm2.059,2.18A27.247,27.247,0,0,1,7.558,18.1,27.075,27.075,0,0,1,5.5,16.258a.964.964,0,0,1-.021-1.34.935.935,0,0,1,1.319,0l.354.355a.558.558,0,0,0,.3.154.566.566,0,0,0,.514-.154l.355-.355a.933.933,0,0,1,1.318,0A.963.963,0,0,1,9.617,16.258Z",
    transform: "translate(-0.452 -1.496)",
    fill: "#ee3d4a"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLove);
export default __webpack_public_path__ + "static/media/menu_love.a9f2ecc014822a0aa18ba5220f2b434f.svg";
export { ForwardRef as ReactComponent };